(ns minorodata.components.dag.core
  "Entry point for the `/dependency-graph` route: the new page behind the
   `fe.new-dependency-graph` flag, the classic bleene page otherwise."
  (:require
   [bleene.root :as b.root]
   [minorodata.components.connections.drawers :as c.connections-drawers]
   [minorodata.components.dependency-graph.page :as dependency-graph.page]
   [minorodata.components.transformations.modals :as t.modals]
   [re-posh.core :as re-posh]))

(def ^:private new-page-flag "fe.new-dependency-graph")

(defn- classic-page
  "The original bleene Konva graph."
  []
  (let [route @(re-posh/subscribe [:app-route/pull])]
    [:<>
     [b.root/root-dispatcher]
     [:f> c.connections-drawers/drawers]
     [t.modals/group-edit-dialog {:route route}]]))

(defn main []
  (let [flag-on? @(re-posh/subscribe [:unleash/is-enabled new-page-flag])]
    (if flag-on?
      [dependency-graph.page/page]
      [classic-page])))
